<template>
    <modal>
        <div slot="header"></div>
        <div slot="body"></div>
        <div slot="footer">
            Service will come soon.
            <button class="modal-default-button" @click="$emit('close')">
                OK
            </button>
        </div>
    </modal>
</template>

<script>
import modal from './elements/modalTemplate';

export default {
  components: {
    modal
  }
};
</script>



// WEBPACK FOOTER //
// src/components/modal.vue